/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthRouteRouteImport } from './routes/auth/route'
import { Route as AppRouteRouteImport } from './routes/_app/route'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as AuthSignUpRouteImport } from './routes/auth/sign-up'
import { Route as AuthSignInRouteImport } from './routes/auth/sign-in'
import { Route as AppPaymentRouteRouteImport } from './routes/_app/payment/route'
import { Route as AppAdminRouteRouteImport } from './routes/_app/admin/route'
import { Route as AppWorksIndexRouteImport } from './routes/_app/works/index'
import { Route as AppSyncsIndexRouteImport } from './routes/_app/syncs/index'
import { Route as AppCollectionsIndexRouteImport } from './routes/_app/collections/index'
import { Route as AppCalendarIndexRouteImport } from './routes/_app/calendar/index'
import { Route as PublicShareSharedWorkIdRouteImport } from './routes/public/share.$sharedWorkId'
import { Route as PublicShareCollectionPublicIdRouteImport } from './routes/public/share-collection.$publicId'
import { Route as AuthPasswordSendResetEmailRouteImport } from './routes/auth/password.send-reset-email'
import { Route as AuthConfirmEmailCodeRouteImport } from './routes/auth/confirm-email.$code'
import { Route as AppPaymentSuccessRouteImport } from './routes/_app/payment/success'
import { Route as AppPaymentErrorRouteImport } from './routes/_app/payment/error'
import { Route as AppPaymentCheckoutRouteImport } from './routes/_app/payment/checkout'
import { Route as AppCollectionsCollectionIdRouteImport } from './routes/_app/collections/$collectionId'
import { Route as AppAdminUsersRouteImport } from './routes/_app/admin/users'
import { Route as AppAdminTagsRouteImport } from './routes/_app/admin/tags'
import { Route as AppAdminSearchTokensRouteImport } from './routes/_app/admin/search-tokens'
import { Route as AuthPasswordResetPasswordCodeTokenRouteImport } from './routes/auth/password.reset-password.$codeToken'

const AuthRouteRoute = AuthRouteRouteImport.update({
  id: '/auth',
  path: '/auth',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRouteRoute = AppRouteRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AuthSignUpRoute = AuthSignUpRouteImport.update({
  id: '/sign-up',
  path: '/sign-up',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthSignInRoute = AuthSignInRouteImport.update({
  id: '/sign-in',
  path: '/sign-in',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AppPaymentRouteRoute = AppPaymentRouteRouteImport.update({
  id: '/payment',
  path: '/payment',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppAdminRouteRoute = AppAdminRouteRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppWorksIndexRoute = AppWorksIndexRouteImport.update({
  id: '/works/',
  path: '/works/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppSyncsIndexRoute = AppSyncsIndexRouteImport.update({
  id: '/syncs/',
  path: '/syncs/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppCollectionsIndexRoute = AppCollectionsIndexRouteImport.update({
  id: '/collections/',
  path: '/collections/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppCalendarIndexRoute = AppCalendarIndexRouteImport.update({
  id: '/calendar/',
  path: '/calendar/',
  getParentRoute: () => AppRouteRoute,
} as any)
const PublicShareSharedWorkIdRoute = PublicShareSharedWorkIdRouteImport.update({
  id: '/public/share/$sharedWorkId',
  path: '/public/share/$sharedWorkId',
  getParentRoute: () => rootRouteImport,
} as any)
const PublicShareCollectionPublicIdRoute =
  PublicShareCollectionPublicIdRouteImport.update({
    id: '/public/share-collection/$publicId',
    path: '/public/share-collection/$publicId',
    getParentRoute: () => rootRouteImport,
  } as any)
const AuthPasswordSendResetEmailRoute =
  AuthPasswordSendResetEmailRouteImport.update({
    id: '/password/send-reset-email',
    path: '/password/send-reset-email',
    getParentRoute: () => AuthRouteRoute,
  } as any)
const AuthConfirmEmailCodeRoute = AuthConfirmEmailCodeRouteImport.update({
  id: '/confirm-email/$code',
  path: '/confirm-email/$code',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AppPaymentSuccessRoute = AppPaymentSuccessRouteImport.update({
  id: '/success',
  path: '/success',
  getParentRoute: () => AppPaymentRouteRoute,
} as any)
const AppPaymentErrorRoute = AppPaymentErrorRouteImport.update({
  id: '/error',
  path: '/error',
  getParentRoute: () => AppPaymentRouteRoute,
} as any)
const AppPaymentCheckoutRoute = AppPaymentCheckoutRouteImport.update({
  id: '/checkout',
  path: '/checkout',
  getParentRoute: () => AppPaymentRouteRoute,
} as any)
const AppCollectionsCollectionIdRoute =
  AppCollectionsCollectionIdRouteImport.update({
    id: '/collections/$collectionId',
    path: '/collections/$collectionId',
    getParentRoute: () => AppRouteRoute,
  } as any)
const AppAdminUsersRoute = AppAdminUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AppAdminRouteRoute,
} as any)
const AppAdminTagsRoute = AppAdminTagsRouteImport.update({
  id: '/tags',
  path: '/tags',
  getParentRoute: () => AppAdminRouteRoute,
} as any)
const AppAdminSearchTokensRoute = AppAdminSearchTokensRouteImport.update({
  id: '/search-tokens',
  path: '/search-tokens',
  getParentRoute: () => AppAdminRouteRoute,
} as any)
const AuthPasswordResetPasswordCodeTokenRoute =
  AuthPasswordResetPasswordCodeTokenRouteImport.update({
    id: '/password/reset-password/$codeToken',
    path: '/password/reset-password/$codeToken',
    getParentRoute: () => AuthRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/auth': typeof AuthRouteRouteWithChildren
  '/admin': typeof AppAdminRouteRouteWithChildren
  '/payment': typeof AppPaymentRouteRouteWithChildren
  '/auth/sign-in': typeof AuthSignInRoute
  '/auth/sign-up': typeof AuthSignUpRoute
  '/': typeof AppIndexRoute
  '/admin/search-tokens': typeof AppAdminSearchTokensRoute
  '/admin/tags': typeof AppAdminTagsRoute
  '/admin/users': typeof AppAdminUsersRoute
  '/collections/$collectionId': typeof AppCollectionsCollectionIdRoute
  '/payment/checkout': typeof AppPaymentCheckoutRoute
  '/payment/error': typeof AppPaymentErrorRoute
  '/payment/success': typeof AppPaymentSuccessRoute
  '/auth/confirm-email/$code': typeof AuthConfirmEmailCodeRoute
  '/auth/password/send-reset-email': typeof AuthPasswordSendResetEmailRoute
  '/public/share-collection/$publicId': typeof PublicShareCollectionPublicIdRoute
  '/public/share/$sharedWorkId': typeof PublicShareSharedWorkIdRoute
  '/calendar': typeof AppCalendarIndexRoute
  '/collections': typeof AppCollectionsIndexRoute
  '/syncs': typeof AppSyncsIndexRoute
  '/works': typeof AppWorksIndexRoute
  '/auth/password/reset-password/$codeToken': typeof AuthPasswordResetPasswordCodeTokenRoute
}
export interface FileRoutesByTo {
  '/auth': typeof AuthRouteRouteWithChildren
  '/admin': typeof AppAdminRouteRouteWithChildren
  '/payment': typeof AppPaymentRouteRouteWithChildren
  '/auth/sign-in': typeof AuthSignInRoute
  '/auth/sign-up': typeof AuthSignUpRoute
  '/': typeof AppIndexRoute
  '/admin/search-tokens': typeof AppAdminSearchTokensRoute
  '/admin/tags': typeof AppAdminTagsRoute
  '/admin/users': typeof AppAdminUsersRoute
  '/collections/$collectionId': typeof AppCollectionsCollectionIdRoute
  '/payment/checkout': typeof AppPaymentCheckoutRoute
  '/payment/error': typeof AppPaymentErrorRoute
  '/payment/success': typeof AppPaymentSuccessRoute
  '/auth/confirm-email/$code': typeof AuthConfirmEmailCodeRoute
  '/auth/password/send-reset-email': typeof AuthPasswordSendResetEmailRoute
  '/public/share-collection/$publicId': typeof PublicShareCollectionPublicIdRoute
  '/public/share/$sharedWorkId': typeof PublicShareSharedWorkIdRoute
  '/calendar': typeof AppCalendarIndexRoute
  '/collections': typeof AppCollectionsIndexRoute
  '/syncs': typeof AppSyncsIndexRoute
  '/works': typeof AppWorksIndexRoute
  '/auth/password/reset-password/$codeToken': typeof AuthPasswordResetPasswordCodeTokenRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteRouteWithChildren
  '/auth': typeof AuthRouteRouteWithChildren
  '/_app/admin': typeof AppAdminRouteRouteWithChildren
  '/_app/payment': typeof AppPaymentRouteRouteWithChildren
  '/auth/sign-in': typeof AuthSignInRoute
  '/auth/sign-up': typeof AuthSignUpRoute
  '/_app/': typeof AppIndexRoute
  '/_app/admin/search-tokens': typeof AppAdminSearchTokensRoute
  '/_app/admin/tags': typeof AppAdminTagsRoute
  '/_app/admin/users': typeof AppAdminUsersRoute
  '/_app/collections/$collectionId': typeof AppCollectionsCollectionIdRoute
  '/_app/payment/checkout': typeof AppPaymentCheckoutRoute
  '/_app/payment/error': typeof AppPaymentErrorRoute
  '/_app/payment/success': typeof AppPaymentSuccessRoute
  '/auth/confirm-email/$code': typeof AuthConfirmEmailCodeRoute
  '/auth/password/send-reset-email': typeof AuthPasswordSendResetEmailRoute
  '/public/share-collection/$publicId': typeof PublicShareCollectionPublicIdRoute
  '/public/share/$sharedWorkId': typeof PublicShareSharedWorkIdRoute
  '/_app/calendar/': typeof AppCalendarIndexRoute
  '/_app/collections/': typeof AppCollectionsIndexRoute
  '/_app/syncs/': typeof AppSyncsIndexRoute
  '/_app/works/': typeof AppWorksIndexRoute
  '/auth/password/reset-password/$codeToken': typeof AuthPasswordResetPasswordCodeTokenRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/auth'
    | '/admin'
    | '/payment'
    | '/auth/sign-in'
    | '/auth/sign-up'
    | '/'
    | '/admin/search-tokens'
    | '/admin/tags'
    | '/admin/users'
    | '/collections/$collectionId'
    | '/payment/checkout'
    | '/payment/error'
    | '/payment/success'
    | '/auth/confirm-email/$code'
    | '/auth/password/send-reset-email'
    | '/public/share-collection/$publicId'
    | '/public/share/$sharedWorkId'
    | '/calendar'
    | '/collections'
    | '/syncs'
    | '/works'
    | '/auth/password/reset-password/$codeToken'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/auth'
    | '/admin'
    | '/payment'
    | '/auth/sign-in'
    | '/auth/sign-up'
    | '/'
    | '/admin/search-tokens'
    | '/admin/tags'
    | '/admin/users'
    | '/collections/$collectionId'
    | '/payment/checkout'
    | '/payment/error'
    | '/payment/success'
    | '/auth/confirm-email/$code'
    | '/auth/password/send-reset-email'
    | '/public/share-collection/$publicId'
    | '/public/share/$sharedWorkId'
    | '/calendar'
    | '/collections'
    | '/syncs'
    | '/works'
    | '/auth/password/reset-password/$codeToken'
  id:
    | '__root__'
    | '/_app'
    | '/auth'
    | '/_app/admin'
    | '/_app/payment'
    | '/auth/sign-in'
    | '/auth/sign-up'
    | '/_app/'
    | '/_app/admin/search-tokens'
    | '/_app/admin/tags'
    | '/_app/admin/users'
    | '/_app/collections/$collectionId'
    | '/_app/payment/checkout'
    | '/_app/payment/error'
    | '/_app/payment/success'
    | '/auth/confirm-email/$code'
    | '/auth/password/send-reset-email'
    | '/public/share-collection/$publicId'
    | '/public/share/$sharedWorkId'
    | '/_app/calendar/'
    | '/_app/collections/'
    | '/_app/syncs/'
    | '/_app/works/'
    | '/auth/password/reset-password/$codeToken'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRouteRoute: typeof AppRouteRouteWithChildren
  AuthRouteRoute: typeof AuthRouteRouteWithChildren
  PublicShareCollectionPublicIdRoute: typeof PublicShareCollectionPublicIdRoute
  PublicShareSharedWorkIdRoute: typeof PublicShareSharedWorkIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/auth': {
      id: '/auth'
      path: '/auth'
      fullPath: '/auth'
      preLoaderRoute: typeof AuthRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AppRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/auth/sign-up': {
      id: '/auth/sign-up'
      path: '/sign-up'
      fullPath: '/auth/sign-up'
      preLoaderRoute: typeof AuthSignUpRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/auth/sign-in': {
      id: '/auth/sign-in'
      path: '/sign-in'
      fullPath: '/auth/sign-in'
      preLoaderRoute: typeof AuthSignInRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_app/payment': {
      id: '/_app/payment'
      path: '/payment'
      fullPath: '/payment'
      preLoaderRoute: typeof AppPaymentRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/admin': {
      id: '/_app/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AppAdminRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/works/': {
      id: '/_app/works/'
      path: '/works'
      fullPath: '/works'
      preLoaderRoute: typeof AppWorksIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/syncs/': {
      id: '/_app/syncs/'
      path: '/syncs'
      fullPath: '/syncs'
      preLoaderRoute: typeof AppSyncsIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/collections/': {
      id: '/_app/collections/'
      path: '/collections'
      fullPath: '/collections'
      preLoaderRoute: typeof AppCollectionsIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/calendar/': {
      id: '/_app/calendar/'
      path: '/calendar'
      fullPath: '/calendar'
      preLoaderRoute: typeof AppCalendarIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/public/share/$sharedWorkId': {
      id: '/public/share/$sharedWorkId'
      path: '/public/share/$sharedWorkId'
      fullPath: '/public/share/$sharedWorkId'
      preLoaderRoute: typeof PublicShareSharedWorkIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/public/share-collection/$publicId': {
      id: '/public/share-collection/$publicId'
      path: '/public/share-collection/$publicId'
      fullPath: '/public/share-collection/$publicId'
      preLoaderRoute: typeof PublicShareCollectionPublicIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/password/send-reset-email': {
      id: '/auth/password/send-reset-email'
      path: '/password/send-reset-email'
      fullPath: '/auth/password/send-reset-email'
      preLoaderRoute: typeof AuthPasswordSendResetEmailRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/auth/confirm-email/$code': {
      id: '/auth/confirm-email/$code'
      path: '/confirm-email/$code'
      fullPath: '/auth/confirm-email/$code'
      preLoaderRoute: typeof AuthConfirmEmailCodeRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_app/payment/success': {
      id: '/_app/payment/success'
      path: '/success'
      fullPath: '/payment/success'
      preLoaderRoute: typeof AppPaymentSuccessRouteImport
      parentRoute: typeof AppPaymentRouteRoute
    }
    '/_app/payment/error': {
      id: '/_app/payment/error'
      path: '/error'
      fullPath: '/payment/error'
      preLoaderRoute: typeof AppPaymentErrorRouteImport
      parentRoute: typeof AppPaymentRouteRoute
    }
    '/_app/payment/checkout': {
      id: '/_app/payment/checkout'
      path: '/checkout'
      fullPath: '/payment/checkout'
      preLoaderRoute: typeof AppPaymentCheckoutRouteImport
      parentRoute: typeof AppPaymentRouteRoute
    }
    '/_app/collections/$collectionId': {
      id: '/_app/collections/$collectionId'
      path: '/collections/$collectionId'
      fullPath: '/collections/$collectionId'
      preLoaderRoute: typeof AppCollectionsCollectionIdRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/admin/users': {
      id: '/_app/admin/users'
      path: '/users'
      fullPath: '/admin/users'
      preLoaderRoute: typeof AppAdminUsersRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/tags': {
      id: '/_app/admin/tags'
      path: '/tags'
      fullPath: '/admin/tags'
      preLoaderRoute: typeof AppAdminTagsRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/search-tokens': {
      id: '/_app/admin/search-tokens'
      path: '/search-tokens'
      fullPath: '/admin/search-tokens'
      preLoaderRoute: typeof AppAdminSearchTokensRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/auth/password/reset-password/$codeToken': {
      id: '/auth/password/reset-password/$codeToken'
      path: '/password/reset-password/$codeToken'
      fullPath: '/auth/password/reset-password/$codeToken'
      preLoaderRoute: typeof AuthPasswordResetPasswordCodeTokenRouteImport
      parentRoute: typeof AuthRouteRoute
    }
  }
}

interface AppAdminRouteRouteChildren {
  AppAdminSearchTokensRoute: typeof AppAdminSearchTokensRoute
  AppAdminTagsRoute: typeof AppAdminTagsRoute
  AppAdminUsersRoute: typeof AppAdminUsersRoute
}

const AppAdminRouteRouteChildren: AppAdminRouteRouteChildren = {
  AppAdminSearchTokensRoute: AppAdminSearchTokensRoute,
  AppAdminTagsRoute: AppAdminTagsRoute,
  AppAdminUsersRoute: AppAdminUsersRoute,
}

const AppAdminRouteRouteWithChildren = AppAdminRouteRoute._addFileChildren(
  AppAdminRouteRouteChildren,
)

interface AppPaymentRouteRouteChildren {
  AppPaymentCheckoutRoute: typeof AppPaymentCheckoutRoute
  AppPaymentErrorRoute: typeof AppPaymentErrorRoute
  AppPaymentSuccessRoute: typeof AppPaymentSuccessRoute
}

const AppPaymentRouteRouteChildren: AppPaymentRouteRouteChildren = {
  AppPaymentCheckoutRoute: AppPaymentCheckoutRoute,
  AppPaymentErrorRoute: AppPaymentErrorRoute,
  AppPaymentSuccessRoute: AppPaymentSuccessRoute,
}

const AppPaymentRouteRouteWithChildren = AppPaymentRouteRoute._addFileChildren(
  AppPaymentRouteRouteChildren,
)

interface AppRouteRouteChildren {
  AppAdminRouteRoute: typeof AppAdminRouteRouteWithChildren
  AppPaymentRouteRoute: typeof AppPaymentRouteRouteWithChildren
  AppIndexRoute: typeof AppIndexRoute
  AppCollectionsCollectionIdRoute: typeof AppCollectionsCollectionIdRoute
  AppCalendarIndexRoute: typeof AppCalendarIndexRoute
  AppCollectionsIndexRoute: typeof AppCollectionsIndexRoute
  AppSyncsIndexRoute: typeof AppSyncsIndexRoute
  AppWorksIndexRoute: typeof AppWorksIndexRoute
}

const AppRouteRouteChildren: AppRouteRouteChildren = {
  AppAdminRouteRoute: AppAdminRouteRouteWithChildren,
  AppPaymentRouteRoute: AppPaymentRouteRouteWithChildren,
  AppIndexRoute: AppIndexRoute,
  AppCollectionsCollectionIdRoute: AppCollectionsCollectionIdRoute,
  AppCalendarIndexRoute: AppCalendarIndexRoute,
  AppCollectionsIndexRoute: AppCollectionsIndexRoute,
  AppSyncsIndexRoute: AppSyncsIndexRoute,
  AppWorksIndexRoute: AppWorksIndexRoute,
}

const AppRouteRouteWithChildren = AppRouteRoute._addFileChildren(
  AppRouteRouteChildren,
)

interface AuthRouteRouteChildren {
  AuthSignInRoute: typeof AuthSignInRoute
  AuthSignUpRoute: typeof AuthSignUpRoute
  AuthConfirmEmailCodeRoute: typeof AuthConfirmEmailCodeRoute
  AuthPasswordSendResetEmailRoute: typeof AuthPasswordSendResetEmailRoute
  AuthPasswordResetPasswordCodeTokenRoute: typeof AuthPasswordResetPasswordCodeTokenRoute
}

const AuthRouteRouteChildren: AuthRouteRouteChildren = {
  AuthSignInRoute: AuthSignInRoute,
  AuthSignUpRoute: AuthSignUpRoute,
  AuthConfirmEmailCodeRoute: AuthConfirmEmailCodeRoute,
  AuthPasswordSendResetEmailRoute: AuthPasswordSendResetEmailRoute,
  AuthPasswordResetPasswordCodeTokenRoute:
    AuthPasswordResetPasswordCodeTokenRoute,
}

const AuthRouteRouteWithChildren = AuthRouteRoute._addFileChildren(
  AuthRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AppRouteRoute: AppRouteRouteWithChildren,
  AuthRouteRoute: AuthRouteRouteWithChildren,
  PublicShareCollectionPublicIdRoute: PublicShareCollectionPublicIdRoute,
  PublicShareSharedWorkIdRoute: PublicShareSharedWorkIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
